import { HTTP } from './axios'
import store from './store'
import router from './router'

const POLL_MS = 3000
let pollTimer = null
let guardInitialized = false

export function forceLogout() {
  if (!store.state.token) {
    return
  }
  store.commit('logOutSuccess')
  stopSessionPoll()
  if (router.currentRoute.path !== '/login') {
    router.replace('/login')
  }
}

export function setupSessionGuard() {
  if (guardInitialized) {
    return
  }
  guardInitialized = true

  HTTP.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401 && store.state.token) {
        forceLogout()
      }
      return Promise.reject(error)
    }
  )
}

export function startSessionPoll() {
  stopSessionPoll()
  if (!store.state.token) {
    return
  }
  checkSession()
  pollTimer = setInterval(checkSession, POLL_MS)
}

export function stopSessionPoll() {
  if (pollTimer) {
    clearInterval(pollTimer)
    pollTimer = null
  }
}

async function checkSession() {
  if (!store.state.token) {
    stopSessionPoll()
    return
  }
  try {
    await HTTP.get('/auth/session-check', {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      },
    })
  } catch (error) {
    if (error.response && error.response.status === 401) {
      forceLogout()
    }
  }
}
